export const isEmpty = <T>(arr?: T[]): boolean => !arr || arr.length === 0;
